module.exports = __webpack_public_path__ + "img/candies.4aea90da.svg";